import * as _ from 'lodash'
import * as Services from "../../../Services";
import * as toastr from "toastr";


export interface IBypassPaymentInfoReceivedEventScope extends ng.IScope {
    bypassPaymentInfoReceivedEventCtrl: BypassPaymentInfoReceivedEventController;
}

export class BypassPaymentInfoReceivedEventController {
    public static $inject = ['$state', '$scope', '$modalInstance', 'CustomerApiClient', 'igsCustomerNumber'];

    constructor(
        public $state: angular.ui.IStateService,
        public $scope: IBypassPaymentInfoReceivedEventScope,
        public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
        private igsCustomerNumber: string,
    ) {
        $scope.bypassPaymentInfoReceivedEventCtrl = this;
    }

    public submitBypass = () => {
        this.customerApiClient
            .submitCustomerEventBypass(this.igsCustomerNumber,'PaymentInformationReceived')
            .then(() => {
                toastr.success(
                    "Success",
                    "The Payment Information Received event was successfully bypassed.",
                );
                this.$modalInstance.close();
                this.$state.reload();
            })
            .catch(() => {
                toastr.error(
                    "Error",
                    "Something went wrong trying to process your request.",
                );
                this.$modalInstance.close();
            })
    }

    public closeModal = () => {
         this.$modalInstance.close();
    }
}
